module.exports = __webpack_public_path__ + "static/media/bg_Page13.3fc75569.jpg";